import { ReactNode, useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import Spinner from '../components/ui/Spinner';
import { AuthContext } from '../context/AuthContext';
import { ActivePhases, useActivePhases } from '../hooks/useControlDate';
import { validateUserPermissions } from '../utils/validateUserPermissions';

interface IPrivateRoute {
    permissions?: string[];
    roles?: string[];
    redirectTo?: string;
    requireManager?: boolean;
    requireNonManager?: boolean;
    requireBanca?: boolean;
    requiredPhase?: (phases: ActivePhases) => boolean;
    children: ReactNode;
}

export function PrivateRoute({ permissions, roles, redirectTo, requireManager, requireNonManager, requireBanca, requiredPhase, children }: IPrivateRoute) {
    const { isAuthenticated, user, loadingUserData } = useContext(AuthContext);
    const location = useLocation();
    const phases = useActivePhases();
    const { hasAllPermissions } = validateUserPermissions({
        user,
        permissions,
        roles
    });

    // Banca técnica SEMPRE volta para login, independente do redirectTo
    // configurado na rota (todas as rotas hoje passam redirectTo="/login", o que
    // sobrescreveria um fallback simples). isBancaUser consulta a flag
    // bb.banca-session, que sobrevive ao clearStorage do signOut.
    const targetRedirect = '/login'


    if (!isAuthenticated) {
        if (location.pathname !== '/login' && location.pathname !== 'login' && location.pathname !== '/') {
            sessionStorage.setItem('return', location.pathname);
        }

        return <Navigate to={targetRedirect} />;
    }

    // Evita redirect prematuro de requireBanca/requiredPhase enquanto o user
    // ainda não chegou do AuthContext (token nos cookies basta para passar o
    // isAuthenticated, mas user.extra.* só está disponível depois do fetch).
    if (loadingUserData) {
        return <Spinner />;
    }

    if (!hasAllPermissions) {
        return <Navigate to="/" />;
    }

    // Comentado para permitir acesso livre às rotas
    // // Verificar se a rota requer manager
    // if (requireManager && user?.detail?.is_manager !== true) {
    //     return <Navigate to="/" />;
    // }

    // // Verificar se a rota requer não-manager
    // if (requireNonManager && user?.detail?.is_manager === true) {
    //     return <Navigate to="/" />;
    // }

    if (requireBanca && (user as any)?.extra?.etapa !== 2) {
        return <Navigate to="/home-public" />;
    }

    // Phase-based access control
    if (requiredPhase && !requiredPhase(phases)) {
        return <Navigate to="/" />;
    }

    return <>{children}</>;
}
